import React, { Component } from 'react';

export default class BoxHeader extends Component {

  render() {
    let titleElements = [];

    if(this.props.title) {
      let icon = this.props.icon || null;
    }

    return(
      <div className="box-header">
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/elements/box/BoxHeader.js